<template>
    <v-dialog
        v-model="dialog"
        @click:outside="closeDialog"
        persistent
        max-width="650px"
        max-height="700px"
        scrollable
        zIndex="210"
    >
        <v-card v-if="dialog">
            <create-company-dialog ref="createCompanyDialog"></create-company-dialog>
            <create-user-dialog ref="createUserDialog"></create-user-dialog>
            <v-toolbar flat dense>
                <h2 class="text-h6 text-primary-700 text-ellipsis-overflow">
                    <span>Editing Enquiry</span>
                </h2>
                <v-spacer></v-spacer>
                <v-btn icon @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn> 
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="py-6" style="max-height: 700px;">
                
                <v-row>
                    <!-- scheme and property -->
                    <v-col cols="12">
                        <v-autocomplete
                            outlined
                            dense
                            hide-details
                            hide-no-data
                            return-object
                            cache-items
                            v-model="form.scheme"
                            :items="schemes.items"
                            :loading="schemes.loading"
                            :search-input.sync="search.scheme"
                            label="Scheme"
                            item-text="name"
                            item-value="id"
                            clearable
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                        <v-autocomplete
                            outlined
                            dense
                            hide-details
                            hide-no-data
                            return-object
                            cache-items
                            v-model="form.property"
                            :items="properties.items"
                            :loading="properties.loading"
                            :search-input.sync="search.property"
                            label="Property"
                            item-text="label"
                            item-value="id"
                            clearable
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                        <v-autocomplete
                            outlined
                            dense
                            hide-details
                            return-object
                            cache-items
                            hide-no-data
                            v-model="form.selectedCompany"
                            :search-input.sync="search.company"
                            :error-messages="formErrors.companyContact ? 'Either contact or company is required' : ''"
                            :items="Companies"
                            label="Company"
                            item-text="name"
                            item-value="id"
                            :loading="companiesLoading"
                            clearable
                        >
                        </v-autocomplete>
                        <div style=" position: absolute;" v-if="checkCompanySearch">No companies found. <a @click="$refs.createCompanyDialog.showDialog();">Create a new company</a></div>
                    </v-col>
                    <v-col cols="12">
                        <v-autocomplete
                            outlined
                            dense
                            hide-details
                            return-object
                            cache-items
                            hide-no-data
                            v-model="form.selectedContact"
                            :search-input.sync="search.contact"
                            :error-messages="formErrors.companyContact ? 'Either contact or company is required' : ''"
                            :items="Contacts"
                            label="Contact"
                            item-text="name"
                            item-value="id"
                            :loading="contactsLoading"
                            clearable
                            ref="contactsCombobox"
                        ></v-autocomplete>
                        <div style="position: absolute;" v-if="checkContactSearch">No contacts found. <a @click="$refs.createUserDialog.showDialog();">Create a new contact</a></div>
                    </v-col>
                </v-row>
                <v-divider class="my-8"></v-divider>
                <v-row>
                    <v-col cols="12">
                        <!-- dropdown for stage -->
                        <v-select
                            outlined
                            dense
                            hide-details
                            v-model="form.stage"
                            :error-messages="formErrors.stage ? 'Stage is required' : ''"
                            :items="stageOptions"
                            :item-title="item => item.label"
                            :item-value="item => item.value"
                            :item-text="'label'"
                            label="Stage"
                            clearable
                            @change="formErrors.stage = false"
                        ></v-select>
                    </v-col>
                    <v-col cols="12">
                        <!-- dropdown for reason -->
                        <v-select
                            outlined
                            dense
                            hide-details
                            v-model="form.reason"
                            :error-messages="formErrors.reason ? 'Reason is required' : ''"
                            :items="reasonOptions"
                            :item-title="item => item.label"
                            :item-value="item => item.value"
                            :item-text="'label'"
                            label="Reason"
                            clearable
                            @change="formErrors.reason = false"
                        ></v-select>

                    </v-col>
                    <v-col cols="12">
                        <!-- <v-text-field
                            outlined
                            dense
                            hide-details
                            v-model="form.received_at"
                            v-validate="''"
                            :error-messages="errors.collect('form.received_at')"
                            placeholder="dd/mm/yyyy"
                            label="Received At"
                            data-vv-name="form.received_at"
                            data-vv-as="Received At"
                            mask="##/##/####"
                            v-mask="'##/##/####'"
                            append-icon="mdi-calendar"
                        ></v-text-field> -->
                        <date-input
                            v-model="form.received_at"
                            label="Received On"
                        ></date-input>
                        
                    </v-col> 
                    <!-- <v-col cols="6">
                        <v-menu offset-y persistent permanent content-class="mt-2" :close-on-content-click="false">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    outlined
                                    dense
                                    hide-details
                                    v-model="form.received_at"
                                    v-validate="''"
                                    :error-messages="errors.collect('form.received_at')"
                                    placeholder="dd/mm/yyyy"
                                    label="Received At"
                                    data-vv-name="form.received_at"
                                    data-vv-as="Received At"
                                    mask="##/##/####"
                                    v-mask="'##/##/####'"
                                    append-icon="mdi-calendar"
                                >
                                    <template v-slot:append>
                                        <transition name="fade">
                                            <v-btn v-if="dateRange" class="rpd-datepicker-btn mr-1" icon @click="dateRange = null"><v-icon>mdi-close</v-icon></v-btn>
                                        </transition>
                                        <v-btn class="rpd-datepicker-btn" icon v-on="on"><v-icon>mdi-calendar</v-icon></v-btn>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker style="width: 100%;" 
                                v-model="dateRange" 
                                persistent
                            ></v-date-picker>
                        </v-menu>
                    </v-col> -->
                </v-row>
                

                <h5 class="text-h7 mb-1 mt-4 pa-0">Size</h5>
                <v-row>
                    <v-col cols="6">
                        <v-text-field
                            outlined
                            dense
                            v-model="form.size_from"
                            label="From (sqft)"
                            hide-details
                            append-icon="mdi-home"
                            return-masked-value
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            outlined
                            dense
                            v-model="form.size_to"
                            label="To (sqft)"
                            hide-details
                            append-icon="mdi-home"
                            return-masked-value
                        ></v-text-field>
                    </v-col>
                </v-row>
                <h5 class="text-h7 mb-1 mt-2 pa-0">Rent</h5>
                <v-row>
                    <v-col cols="6">
                        <!-- <v-text-field
                            outlined
                            dense
                            hide-details
                            v-model="form.rent_from"
                            prefix="£"
                            label="From"
                            hint="£"
                            return-masked-value
                        ></v-text-field> -->
                        <currency-input
                            ref="rentFrom"
                            v-model="form.rent_from"
                            :validation="'decimal:2'"
                            label="Rent From"
                            :errorMsgs="errors.collect('form.rent_from')"
                        ></currency-input>
                    </v-col>
                    <v-col cols="6">
                        <!-- <v-text-field
                            outlined
                            dense
                            hide-details
                            v-model="form.rent_to"
                            label="To"
                            prefix="£"
                            hint="£"
                            return-masked-value
                        ></v-text-field> -->
                        <currency-input
                            ref="rentTo"
                            v-model="form.rent_to"
                            :validation="'decimal:2'"
                            label="Rent To"
                            :errorMsgs="errors.collect('form.rent_to')"
                        ></currency-input>
                    </v-col>
                </v-row>

                <v-row class="mx-0 py-0 mb-4" align="center">
                    <div>
                        <h5 class="text-h7 pa-0">Created: {{ entity.created_at }}</h5>
                        <h5 class="text-h7 pa-0">Updated: {{ entity.updated_at }}</h5>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn
                        :elevation="0"
                        color="error"
                        class="mr-2"
                        height="40"
                        outlined
                        @click="closeDialog"
                    >
                        Discard Changes
                    </v-btn>
                    <v-btn
                        :elevation="0"
                        color="primary"
                        height="40"
                        @click="editEnquiry(entity)"
                    >
                        Save
                    </v-btn>
                </v-row>
                <comments class="mt-8" :hideHeader="true" :entityId="entity.id" :entityType="'enquiry'" refs="commentRef" @contentStatus="checkContent"></comments>
            </v-card-text>
            <!-- <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                
            </v-card-actions> -->
        </v-card>
    </v-dialog>
</template>
<script>
    import {mask} from 'vue-the-mask'
    import Comments from '@/components/common/comments'
    import CreateCompanyDialog from '@/components/companies/createCompanyDialog'
    import CreateUserDialog from '@/components/users/createUserDialog'
    import currencyInput from "@/components/common/currencyInput.vue";
    import dateInput from '@/components/common/dateInput.vue'
    export default {
        components: {
            Comments,
            CreateCompanyDialog,
            CreateUserDialog,
            currencyInput,
            dateInput,
        },
        directives: {
            mask,
        },
        data() {
            return {
                entity: null,

                dialog: false,
                form: {
                    scheme: null,
                    property: null,
                    selectedCompany: null,
                    selectedContact: null,
                    stage: null,
                    reason: null,
                    received_at: null,
                    size_to: null,
                    size_from: null,
                    rent_from: null,
                    rent_to: null,
                },
                    

                Companies: [],
                Contacts: [],
                stage: '',
                stageOptions: [
                    {value: 'interest', label: 'Interest'},
                    {value: 'under_offer', label: 'Under Offer'},
                    {value: 'completed', label: 'Completed'},
                    {value: 'withdrawn', label: 'Withdrawn'},
                ],
                reason: null,
                reasonOptions: [
                    {value: 'new_store', label: 'New Store'},
                    {value: 'relocation', label: 'Relocation'},
                    {value: 'upsize', label: 'Upsize'},
                    {value: 'downsize', label: 'Downsize'},
                    {value: null, label: 'Unknown'},
                ],
                companiesLoading: false,
                contactsLoading: false,
                commentStatus: false,
                formErrors: {
                    companyContact: false,
                    stage: false,
                    reason: false,
                },

                dateRange: null,

                properties: {
                    items: [],
                    loading: false,
                },
                schemes: {
                    items: [],
                    loading: false,
                },

                search: {
                    company: '',
                    contact: '',
                    property: '',
                    scheme: '',
                },
            }
        },
        methods: {
            closeDialog(e){
                if(this.commentStatus){
                    this.$notify.question('An unsaved comment exists, Do you still wish to close?', () => {
                        this.dialog = false
                    })
                }else{
                    this.dialog = false
                }
            },
            openDialog(entity) {
                this.resetForm()
                this.entity = entity
                this.dialog = true;

                this.$nextTick(() => {
                    this.fillForm(entity)
                })
            },

            fillForm(entity){
                // fill scheme and property
                if(entity.property_id){
                    let property = entity.property.data
                    property.label = `${property.building_num} ${property.address.data.full_address}`
                    this.form.property = property
                    this.properties.items = [property]
                }
                if(entity.scheme_id){
                    this.form.scheme = entity.scheme.data;
                    this.schemes.items = [entity.scheme.data]
                }
                if(entity.company.data.length != 0){
                    this.form.selectedCompany = entity.company.data
                    this.Companies = [entity.company.data]
                }
                if(entity.user.data.length != 0){
                    this.form.selectedContact = entity.user.data
                    this.Contacts = [entity.user.data]
                }

                if (entity.stage){
                // replace any spaces with _
                this.form.stage = entity.stage.replace(/ /g, '_')
                }
                
                if(entity.reason){
                    if(entity.reason == 'unknown'){
                        this.form.reason = null
                    }else{
                         // replace any spaces with _
                        this.form.reason = entity.reason.replace(/ /g, '_')
                    }
                }

                this.form.received_at = entity.received_at

                // if(entity.company.data.length != 0)
                // this.form.selectedCompany = {value: entity.company.data.id, label: entity.company.data.name}
                // if(entity.user.data.length != 0)
                // this.form.selectedContact = {value: entity.user.data.id, label: entity.user.data.name}
                
                this.form.size_from = entity.size_from
                this.form.size_to = entity.size_to
                
                this.$refs.rentFrom.setValue(entity.rent_from)
                this.$refs.rentTo.setValue(entity.rent_to)
            },

            searchProperty(prop){
                if (!prop) return
                this.properties.loading = true
                this.properties.items = []
                this.getProperties(prop)
            },

            searchScheme(prop){
                if (!prop) return
                this.schemes.loading = true
                this.schemes.items = []
                this.getSchemes(prop)
            },

            searchCompanies(prop){
                if (!prop) return
                this.companiesLoading = true
                this.Companies = []
                this.getCompanies(prop)
            },

            searchContacts(prop){
                if(!prop) return
                this.contactsLoading = true
                this.Contacts = []
                this.getContacts(prop)
            },

            async getProperties(prop){
                // gets properties for dropdown
                this.$http.get("/properties/simple",{
                params: {
                    q: prop,
                    per_page: 50,
                    include: 'address,tenant,scheme',
                }
                }).then(response => {
                    this.properties.items = response.data.data.map(property => {
                        let tenant = property.tenant.data.name ? property.tenant.data.name + ',' : 'Vacant,'
                        let unit = property.building_num ? property.building_num : ''
                        if(property.scheme_id){
                            property.label = `${tenant} ${unit} ${property.scheme.data.name}, ${property.address.data.full_address}`
                        }else{
                            property.label = `${tenant} ${unit} ${property.address.data.full_address}`
                        }
                        return property
                    })
                    this.properties.loading = false
                }).catch(error => {
                    this.properties.loading = false
                })
            },

            async getSchemes(prop){
                // gets schemes for dropdown
                this.$http.get("/schemes?include=address",{
                    params: {
                    q: prop,
                    per_page: 50,
                    }
                }).then(response => {
                    this.schemes.items = response.data.data
                    this.schemes.loading = false
                }).catch(error => {
                    this.schemes.loading = false
                })
            },

            async getCompanies(prop){
                this.formErrors.companyContact = false
                this.$http.get("/companies",{
                params: {
                    q: prop,
                    per_page: 50,
                }
                }).then(response => {
                this.Companies = response.data.data
                this.companiesLoading = false
                }).catch(error => {
                this.companiesLoading = false
                })
            },

            async getContacts(prop){
                this.formErrors.companyContact = false
                this.$http.get("/users",{
                params: {
                    q: prop,
                    per_page: 50,
                }
                }).then(response => {
                this.Contacts = response.data.data
                this.contactsLoading = false
                }).catch(error => {
                this.contactsLoading = false
                })
            },

            async editEnquiry(){
                this.formErrors.stage = false
                this.formErrors.reason = false
                let reason
                if (!this.validateForm()) return
                // if there is property id, use it, else use scheme id
                if(this.form.reason == null){
                    reason = 'unknown'
                }else{
                    reason = this.form.reason
                }
                let type = this.entity.property_id ? 'property' : 'scheme'
                this.$http.put('/enquiries/' + this.entity.id,{
                    scheme_id: this.form.scheme ? this.form.scheme.id : null,
                    property_id: this.form.property ? this.form.property.id : null,
                    company_id: this.form.selectedCompany ? this.form.selectedCompany.id : null,
                    user_id: this.form.selectedContact ? this.form.selectedContact.id : null,
                    received_at: this.formatDate(this.form.received_at),
                    size_to: this.form.size_to,
                    size_from: this.form.size_from,
                    rent_from: this.form.rent_from,
                    rent_to: this.form.rent_to,
                    stage: this.form.stage,
                    reason: reason
                }).then(response => {
                    this.entity.updated_at = new Date().toLocaleDateString()
                    this.$emit('edited', this.form, this.entity)
                }).catch(error => {
                })
            },

            validateForm(){
                let errors = false
                if(this.form.selectedCompany == null && this.form.selectedContact == null){
                this.formErrors.companyContact = true
                errors = true
                }
                if(this.form.stage == '' || this.form.stage == null){
                this.formErrors.stage = true
                errors = true
                }
                return !errors
            },

            formatDate(date){
                // change from DD/MM/YYYY to MM/DD/YYYY
                let dateArray = date.split('/')
                return dateArray[1] + '/' + dateArray[0] + '/' + dateArray[2]
                
                
            },

            resetForm(){
                this.form = {
                    selectedCompany: null,
                    selectedContact: null,
                    stage: null,
                    reason: null,
                }
                this.formErrors = {
                    companyContact: false,
                    stage: false,
                    reason: false,
                }
                this.commentStatus = false
            },

            checkContent(status){
                this.commentStatus = status
            }

        },
        watch:{
            dateRange() {
                if (this.dateRange) {
                    // format dates first from YYYY-MM-DD to DD/MM/YYYY
                    this.form.received_at = this.dateRange.split('-').reverse().join('/')
                } else {
                    this.form.received_at = ''
                }
            },

            'search.property' (newValue) {
                this.searchProperty(newValue)
            },
            'search.scheme' (newValue) {
                this.searchScheme(newValue)
            },
            'search.company' (newValue) {
                this.searchCompanies(newValue)
            },
            'search.contact' (newValue) {
                this.searchContacts(newValue)
            },


        },
        computed: {
            checkCompanySearch(){
                return (this.Companies.length == 0 & !this.companiesLoading & (this.search.company && this.search.company.length > 0)) & !this.formErrors.companyContact & (!this.form.selectedCompany || typeof this.form.selectedCompany == 'string')
            },
            checkContactSearch(){
                return (this.Contacts.length == 0 & !this.contactsLoading & (this.search.contact && this.search.contact.length > 0)) & !this.formErrors.companyContact & (!this.form.selectedContact || typeof this.form.selectedContact == 'string')
            },
        },
    }
</script>